import React from 'react'

const RADIUS_OPTIONS = [5, 10, 25, 50, 75, 100, 125, 150, 200, 250]

function RadiusSelect({
	value,
	onChange,
	disabled = false,
	isDarkMode = false,
}) {
	return (
		<select
			value={value}
			onChange={onChange}
			disabled={disabled}
			className={`
				text-[10px] px-1.5 rounded border min-w-[60px] h-6 leading-none
				transition-colors cursor-pointer appearance-none
				bg-no-repeat bg-[length:12px] bg-[center_right_3px]
				focus:outline-none focus:ring-1 focus:ring-blue-500
				${
					isDarkMode
						? 'bg-gray-800 border-gray-600 text-gray-200 hover:bg-gray-700'
						: 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
				}
				${disabled ? 'opacity-50 cursor-not-allowed hover:bg-transparent' : ''}
			`}
			style={{
				backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236B7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E")`,
				paddingRight: '20px',
				paddingTop: '1px',
				paddingBottom: '1px'
			}}
		>
			{RADIUS_OPTIONS.map(radius => (
				<option key={radius} value={radius}>
					{radius} mi
				</option>
			))}
		</select>
	)
}

export default RadiusSelect
